import { prop } from 'ramda';
import { MediaManagerSDKAnyItem } from './media-manager-sdk';

export const getId: (item: MediaManagerSDKAnyItem) => string = prop('id');
